import { Action } from 'redux'
import { isType } from 'ts-action'
import { ICalendarEventsReducer } from 'models/CalendarEvent'
import {
  GetCalendarEvents,
  CalendarEventsFetching,
  GetCalendarEventsErrors,
} from './actions'

const initialState: ICalendarEventsReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const calendarEventsReducer = (
  state = initialState,
  action: Action,
): ICalendarEventsReducer => {
  if (isType(action, GetCalendarEvents)) {
    const { payload } = action
    return {
      ...state,
      data: payload,
    }
  }

  if (isType(action, GetCalendarEventsErrors)) {
    const { payload } = action
    return {
      ...state,
      error: {
        code: payload.code,
        message: payload.message,
      },
    }
  }

  if (isType(action, CalendarEventsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
